var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1BillionNormalstage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 74,
    viewBox: "0 0 96 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_729_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1487 72.0892H7.85128C4.30392 72.0892 1.42749 69.2128 1.42749 65.6654V7.85128C1.42749 4.30392 4.30392 1.42749 7.85128 1.42749H88.1487C91.696 1.42749 94.5725 4.30392 94.5725 7.85128V65.6654C94.5725 69.2128 91.696 72.0892 88.1487 72.0892Z",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42749 14.2751H94.5725",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0521 9.34573C24.1103 9.34573 24.9681 8.4879 24.9681 7.4297C24.9681 6.3715 24.1103 5.51367 23.0521 5.51367C21.9939 5.51367 21.136 6.3715 21.136 7.4297C21.136 8.4879 21.9939 9.34573 23.0521 9.34573Z",
    stroke: "#B3B3B3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6193 9.34573C17.6775 9.34573 18.5354 8.4879 18.5354 7.4297C18.5354 6.3715 17.6775 5.51367 16.6193 5.51367C15.5611 5.51367 14.7033 6.3715 14.7033 7.4297C14.7033 8.4879 15.5611 9.34573 16.6193 9.34573Z",
    stroke: "#B3B3B3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1867 9.34573C11.2449 9.34573 12.1027 8.4879 12.1027 7.4297C12.1027 6.3715 11.2449 5.51367 10.1867 5.51367C9.12846 5.51367 8.27063 6.3715 8.27063 7.4297C8.27063 8.4879 9.12846 9.34573 10.1867 9.34573Z",
    stroke: "#B3B3B3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8475 31.9404H80.1189C82.7812 31.9404 84.9368 34.096 84.9368 36.7583C84.9368 39.4206 82.7812 41.5761 80.1189 41.5761H60.8475",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.881 41.5761C13.2187 41.5761 11.0632 39.4206 11.0632 36.7583C11.0632 34.096 13.2187 31.9404 15.881 31.9404",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0892 31.9404V41.5761",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3643 52.8179C47.2337 52.8179 54.4238 45.6279 54.4238 36.7585C54.4238 27.8891 47.2337 20.699 38.3643 20.699C29.4949 20.699 22.3048 27.8891 22.3048 36.7585C22.3048 45.6279 29.4949 52.8179 38.3643 52.8179Z",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5762 35.1526V38.3645",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1524 30.3347V43.1823",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7286 35.1526V38.3645",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 33.5466V39.9704",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2889 44.8701L65.7796 57.3608C67.6604 59.2416 67.6604 62.2929 65.7796 64.1736C63.8989 66.0544 60.8476 66.0544 58.9668 64.1736L46.4761 51.6829",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_729_129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 73.5167,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1BillionNormalstage);
export default __webpack_public_path__ + "static/media/1_Billion_Normalstage.f8aa68931d1baf0e571e0e27edd5f322.svg";
export { ForwardRef as ReactComponent };